// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import zutil from 'zutil';
import {Proxy_type, t_generated_proxy, t_order, t_orders, t_zone_group}
    from '../../../../hola/pub/ui/pro/cp/orders';
import date from '/util/date.js';
import hola_opt from 'hola_opt';
import {convert_byte_to_gb, get_usage_info,
    is_order_expired,
    order_has_renew_error} from '../../../../toolip/pub/ui/dashboard/utils';
import {t_free_zone_params} from '../../../../toolip/pub/lib/use_dashboard_data';

export const DEFAULT_IPS_AMOUNT = 10000;

export const date_fmt =
    (x: string): string=>x && date?.strftime('%b %d, %Y', x);

export const download_csv = (type: string, proxies?: t_generated_proxy[])=>{
    if (!proxies?.length)
      return;
    try {
        (window as any).dataLayer.push({
            event: 'gtag.download_proxy',
        });
    } catch(e){}
    const csv_fn = `${type}-${date.strftime('%d-%b-%y', new Date())}.csv`;
    const content = proxies_to_csv(proxies.filter(p=>p.manually_changed));
    do_download_file(csv_fn, content);
};

export const download_json = (type: string, proxies?: t_generated_proxy[])=>{
    if (!proxies?.length)
      return;
    try {
        (window as any).dataLayer.push({
          event: 'gtag.download_proxy',
        });
    } catch(e){}
    const csv_fn = `${type}-${date.strftime('%d-%b-%y', new Date())}.json`;
    const content = proxies_to_json(proxies.filter(p=>p.manually_changed));
    do_download_file(csv_fn, content);
};

const proxies_to_csv = (proxies: t_generated_proxy[])=>{
    const header = 'login,password,host,port,ip,country,socks5';
    const proxy_to_line = (p:t_generated_proxy)=>
      [p.login, p.password, p.host, p.port, p.ip,
        p.country, p.socks5].join(',');
    return [
        header, ...proxies.map(proxy_to_line),
    ].join('\n');
};

const proxies_to_json = (proxies: t_generated_proxy[])=>{
    const fields = ['login', 'password', 'host', 'port', 'ip', 'country',
        'socks5'];
    return JSON.stringify(proxies.map(p=>zutil.pick(p, fields)), null, 2);
};

const do_download_file = (fn: string, content: string)=>{
    const blob = new Blob([content], {type: 'text/csv'});
    const el = document.createElement('a');
    el.href = URL.createObjectURL(blob);
    el.download = fn;
    el.click();
    URL.revokeObjectURL(el.href);
};

export const has_expired_orders = (orders?: t_orders)=>{
    return orders && Object.values(orders).some(oo=>oo.some(is_order_expired));
};

export const total_orders_count = (orders:t_orders)=>{
    if (!orders)
        return 0;
    let total = 0;
    Object.values(orders).forEach(v=>total+=v.length);
    return total;
};

export const has_free_plan = (orders:t_orders)=>{
    if (!orders)
        return false;
    for (const oo of Object.values(orders))
    {
        if (oo.some(o=>o.free_zone))
            return true;
    }
    return false;
};

export const has_active_plan = (orders:t_orders)=>{
    if (!orders)
        return false;
    return Object.values(orders)
        .some(by_type=>by_type.some(item=>!is_order_expired(item)));
};


export const show_free_plan_promo = (orders:t_orders,
    free_zone_params: t_free_zone_params)=>
{
    const empty_orders = total_orders_count(orders) == 0;
    return empty_orders && !free_zone_params;
};

const empty_proxy = {host: '', port: '', ip: '', manually_changed: true,
    login: '', password: '', socks5: false};

export const get_free_zone = (params?: t_free_zone_params)=>{
    if (!params)
        return null;
    const proxies = new Array(1).fill(
        {country: params.country??'us', ...empty_proxy});
    const free_zone_fake: t_order = {
        _id: 'free_fake',
        zone: params.type,
        client_id: 'free',
        free_zone: true,
        start: new Date().toISOString(),
        until: new Date(new Date().setDate(new Date().getDate() + 7))
            .toISOString(),
        limit: 100000000,
        generated_proxies: proxies,
        ips_amount: 1,
        type: params.type,
        usage_info: {used: 0},
        unit: 'gb'
    };
    return free_zone_fake;
};

export const new_order_ids = (orders:t_orders)=>{
    if (!orders)
        return [];
    let ids: string[] = [];
    Object.values(orders).forEach(v=>ids = ids.concat(
        v.filter(o=>o.user_state?.is_new).map(o=>o._id)));
    return ids;
};

export const expired_order_ids = (orders:t_orders)=>{
  if (!orders)
      return [];
  let ids: string[] = [];
  Object.values(orders).forEach(v=>ids = ids.concat(
      v.filter(o=>o.expired_recently && !o.user_state?.expired_seen)
          .map(o=>o._id)));
  return ids;
};

interface i_orders_stats {
    active_plans: number;
    generated_amount: number;
    countries_accessed: number;
}

export const get_orders_stats = (orders: t_orders)=>{
    if (!orders)
        return {} as i_orders_stats;
    const stats: i_orders_stats = {
        active_plans: 0,
        generated_amount: 0,
        countries_accessed: 0,
    };
    Object.keys(orders).forEach(type=>{
        const _orders = orders[type] as t_order[];
        const _countries = [];
        _orders.forEach(item=>{
            if (!is_order_expired(item))
                stats.active_plans += 1;
            const generated = item.generated_proxies
                .filter(p=>p.manually_changed);
            stats.generated_amount += generated.length;
            _countries.push(...generated.map(p=>p.country));
        });
        stats.countries_accessed = new Set(_countries).size;
    });
    return stats;
};

export const align_table_sizes = tables=>{
    if (!tables.length || !tables[0].rows?.length)
        return;
    const run_for_all_cells = (cols, fn)=>{
        tables.forEach(table=>{
            for (let n = 0; n < table.rows.length; n++)
            {
                const row = table.rows[n];
                for (let i = 0; i < cols; i++)
                {
                    const cell = row.cells[i];
                    fn(cell, i);
                }
            }
        });
    };
    const cols_count = tables[0].rows[0].cells.length;
    const cols_widths = new Array(cols_count).fill(0);
    run_for_all_cells(cols_count, cell=>{
        cell.style.minWidth = ``;
    });
    run_for_all_cells(cols_count, (cell, i)=>{
        cols_widths[i] = Math.max(cols_widths[i], cell.offsetWidth);
    });
    run_for_all_cells(cols_count, (cell, i)=>{
        cell.style.minWidth = `${cols_widths[i]}px`;
    });
};

export const get_visible_actions = (order: t_order)=>{
    if (!order || order.type == Proxy_type.UNKNOWN)
        return {};
    if (order_has_renew_error(order)
        && (date(order.subscription_until) < date() || order.expired_recently))
    {
        return {update_payment: true};
    }
    if (order.expired_recently)
        return {buy_new: true};
    const generated = order.generated_proxies ?? [];
    const generate = order.unit=='ip'
        ? generated.some(p=>!p.manually_changed)
        : true;
    const config_list = order.unit=='ip'
        ? generated.some(p=>p.manually_changed)
        : generated.length>0;
    const has_expired_limits = get_usage_info(order)?.extra
        ?.some(e=>e.is_full_usage);
    return {config_list, generate, has_expired_limits};
};

export const get_order = (id: string, type: string, orders: t_orders)=>{
    return (orders?.[type]||[]).find(o=>o?._id==id) as t_order;
};

export const get_payment_extra_url = ({zone_id, group_id, extra_limit, price}:
    object_of<string|number>,
)=>{
    let ids = `zone_id=${zone_id}`;
    if (group_id)
        ids += `&group_id=${group_id}`;
    const qs = `${ids}&extra_limit=${extra_limit}&price=${price}`;
    return `/pricing/checkout?${qs}`;
};

export const get_group_price_per_gb = (group: t_zone_group)=>{
    if (!group || !group.zones?.length)
        return null;
    const {plan_id} = group;
    const zone = group.zones[0];
    const {plan_limit} = zone;
    const gb_limit = convert_byte_to_gb(plan_limit);
    const plan = hola_opt.all_plans.find(p=>p.id==plan_id);
    const per_gb = (plan?.price ?? 0) / gb_limit;
    return per_gb;
};

export const get_price_per_gb = (order: t_order)=>{
    if (!order)
        return null;
    const {plan_price, plan_id, is_legacy, plan_limit} = order;
    const gb_limit = convert_byte_to_gb(plan_limit);
    let per_gb;
    if (is_legacy)
        per_gb = plan_price / gb_limit;
    else
    {
        const plan = hola_opt.all_plans.find(p=>p.id==plan_id);
        per_gb = (plan?.price ?? 0) / gb_limit;
    }
    return per_gb;
};

export const is_unlimited_proxy_type =
  (t: Proxy_type)=>[Proxy_type.ISPPREM, Proxy_type.EV_ISP].includes(t);
